import store from '@/plugins/vuex'

const routes = [
  {
    path: '/artist/home',
    name: 'Artist Dashboard',
    beforeEnter(to, from, next) {
      store.commit('artistDashboard/setSelectedTrack', null)
      store.commit('artistDashboard/setSelectedArtist', null)
      next()
    },
    component: () =>
      import(/* webpackChunkName: 'dashboard-artist' */ './views/Index.vue')
  }
]

export default routes
